import '../../style/SliderWrapperNew.css';
import next from '../../images/next.svg'
import previous from '../../images/previous.svg'
import { useRef, useEffect, useState } from 'react'

const SliderWrapperNew = ({ height, bgColor, isImageSlider, sliderData, review, mobileNav }) => {

    const outerSliderContainer = useRef()
    const innerSliderContainer = useRef()
    const currentTranslation = useRef(0)
    const [innerSliderWidth, setInnerSliderWidth] = useState(0)
    const [sliderItemWidth, setSliderItemWidth] = useState(0)
    const screenWidth = window.innerWidth

    useEffect(() => {

        if (screenWidth > 700 && screenWidth < 1200){
            setSliderItemWidth(outerSliderContainer.current.clientWidth / 3 - 10)
        }
        else{
            setSliderItemWidth(outerSliderContainer.current.clientWidth / 4 - 10)
        }
        setInnerSliderWidth(sliderData.length * sliderItemWidth + 75)
        
    }, [screenWidth, sliderData, sliderItemWidth])

    const renderReviewItem = sliderData.map((x, i) => {
        return (
            <div className="comment slider-item" style={{width: `${mobileNav ? 240 : sliderItemWidth}px`, transition: 'all 0.4s', transform: 'scale(1)'}} key={i}>
                <div className="item-header">   

                    <span className="avatar">
                        <img src={x.image} alt="profile"/>
                    </span>
                    <span className="author">{x.name}</span>
                </div>
                <div className="content">   
                <div className="text" dangerouslySetInnerHTML={{ __html: x.msge }}>
                </div>
                </div>
            </div>
        )
    })
    const renderNonImageItem = null;
    const renderImageItem = sliderData.map(x => {
        return (
            <div className="slider-item">

            </div>
        )
    })
    const slideLeft = () => {
        let scrollable;
        if (screenWidth > 700 && screenWidth < 1200){
            scrollable = (sliderData.length - 3) * (outerSliderContainer.current.clientWidth / 3)
            if (currentTranslation.current > -scrollable){
                const slideWidth = outerSliderContainer.current.clientWidth / 3
                currentTranslation.current -= slideWidth
                innerSliderContainer.current.style.transform = `translateX(${currentTranslation.current}px)`
            }

        }else{
            scrollable = (sliderData.length - 4) * (outerSliderContainer.current.clientWidth / 4)
            if (currentTranslation.current > -scrollable){
                const slideWidth = outerSliderContainer.current.clientWidth / 4
                currentTranslation.current -= slideWidth
                innerSliderContainer.current.style.transform = `translateX(${currentTranslation.current}px)`
                console.log(slideWidth)
            }

        }
        
    }
    const slideRight = () => {

        if (screenWidth > 700 && screenWidth < 1200){
            if (currentTranslation.current < 0){
                const slideWidth = outerSliderContainer.current.clientWidth / 3
                currentTranslation.current += slideWidth
                innerSliderContainer.current.style.transform = `translateX(${currentTranslation.current}px)`
            }
            
        }else{
            if (currentTranslation.current < 0){
                const slideWidth = outerSliderContainer.current.clientWidth / 4
                currentTranslation.current += slideWidth
                innerSliderContainer.current.style.transform = `translateX(${currentTranslation.current}px)`
                console.log(slideWidth)
            }
        }

        
        
    }
    const renderSliderHandle = () => {
        if (!mobileNav){
           return(
              <>
                <img src={previous} alt="slider-handle" style={{position: 'absolute', top: "0", bottom:"0", left:"-20px", zIndex:"1", margin: 'auto 0', padding: '3px', backgroundColor: 'white', borderRadius: '50%'}} width={35} onClick={slideLeft}/>
                <img src={next} alt="slider-handle" style={{position: 'absolute', top: "0", bottom:"0", right: '-10px', zIndex: "1", margin: 'auto 0', padding: '3px', backgroundColor: 'white', borderRadius: '50%'}} height={35} onClick={slideRight}/>
               </>
            )
         }
       }
    const innerContainerStyle = mobileNav ? {width: '100%', maxWidth: `${innerSliderWidth}px`} : {width: `${innerSliderWidth}px`, maxWidth: `${innerSliderWidth}px`, transition: 'all 0.4s', transform: 'translateX(0px)'}
    return (
        <div style={{position: 'relative', height: '100%'}}>
            {renderSliderHandle()}
            <div className="main-slider__container" style={{height: height}}>
                <div className="slider-outer__container" ref={outerSliderContainer}>
                    <div className={`slider-inner__container ${isImageSlider ? "" : "ui comments fluid"}`} ref={innerSliderContainer} style={innerContainerStyle}>
                        {review ? renderReviewItem : isImageSlider ? renderImageItem : renderNonImageItem}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SliderWrapperNew